// Central site configuration. Update contact details here.
export const SITE = {
  name: "ShipKorea.in",
  legalName: "ShipKorea Logistics",
  tagline: "South Korea is Just 5 Days Away",
  url: "https://www.shipkorea.in",
  logo: "/shipkorea-logo.png",
  logoBox: "/shipkorea-box.png",
  description:
    "ShipKorea.in is India's trusted courier service to South Korea. Fast, secure, door-to-door parcel delivery from India to South Korea with free pickup, duty-paid (DDP) delivery and customs clearance in just 5 days.",
  // Contact
  whatsapp: "+917800320078",
  whatsappDisplay: "+91 78003 20078",
  phone: "+917800320078",
  phoneDisplay: "+91 78003 20078",
  email: "Admin@shipkorea.in",
  supportEmail: "Admin@shipkorea.in",
  address: "Pole No. 137, VPO Rajokari, New Delhi, India 110038",
  hours: "Mon–Sat, 9:00 AM – 8:00 PM IST",
  social: {
    facebook: "https://facebook.com/",
    instagram: "https://instagram.com/",
    linkedin: "https://linkedin.com/",
    twitter: "https://twitter.com/",
  },
};

export const NAV = [
  { label: "India → Korea", to: "/india-to-south-korea-courier" },
  { label: "Korea → India", to: "/south-korea-to-india-courier" },
  {
    label: "Services",
    children: [
      { label: "Send to South Korea (Guide)", to: "/send-to-south-korea-from-india" },
      { label: "DDP Shipping", to: "/ddp-shipping" },
      { label: "Excess Luggage", to: "/excess-luggage" },
      { label: "Commercial Shipping", to: "/commercial-shipping" },
      { label: "Student Shipping", to: "/student-shipping" },
      { label: "Proxy Shopping (Buy from Korea)", to: "/proxy-shopping" },
      { label: "Proxy Shopping in India (for Koreans)", to: "/proxy-shopping-in-india" },
      { label: "Business Sourcing", to: "/business-sourcing" },
      { label: "Import Export Consulting", to: "/import-export-consulting" },
      { label: "Custom Clearance", to: "/custom-clearance" },
      { label: "Warehouse Consolidation", to: "/warehouse" },
      { label: "Insurance", to: "/insurance" },
      { label: "Packaging", to: "/packaging" },
      { label: "South Korea Customs Guide", to: "/south-korea-customs-guide" },
      { label: "What You Can Send", to: "/what-you-can-send-to-south-korea" },
    ],
  },
  { label: "Pricing", to: "/pricing" },
  { label: "Blog", to: "/blog" },
  { label: "FAQ", to: "/faq" },
];

export const whatsappLink = (msg = "Hi ShipKorea, I'd like to send a parcel to South Korea.") =>
  `https://wa.me/${SITE.whatsapp.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(msg)}`;
